module.exports = __webpack_public_path__ + "img/icon-state-calendar.b1eb5711.svg";